export const SERVER = {
  BASE_API: ''
}
SERVER.BASE_API = 'https://ws.wordscan.net'
// SERVER.BASE_API = '/api' // 本地跨域
export default {
  sendEmailCode: `${SERVER.BASE_API}/api/student/send_email`,
  bindUser: `${SERVER.BASE_API}/api/student/bind_user`
}



// WEBPACK FOOTER //
// ./src/http/api.js